import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { FolderKanban, Wrench, Mail, TrendingUp } from "lucide-react";

export default function Dashboard() {
  const [counts, setCounts] = useState({ projects: 0, services: 0, messages: 0, unread: 0 });

  useEffect(() => {
    Promise.all([api.get("/projects"), api.get("/services"), api.get("/messages")]).then(([p, s, m]) => {
      setCounts({
        projects: p.data.length,
        services: s.data.length,
        messages: m.data.length,
        unread: m.data.filter((x) => !x.read).length,
      });
    }).catch(() => {});
  }, []);

  const CARDS = [
    { icon: FolderKanban, label: "Toplam Proje", value: counts.projects, to: "/admin/projects" },
    { icon: Wrench, label: "Hizmetler", value: counts.services, to: "/admin/services" },
    { icon: Mail, label: "Mesajlar", value: counts.messages, to: "/admin/messages" },
    { icon: TrendingUp, label: "Okunmamış Mesaj", value: counts.unread, to: "/admin/messages" },
  ];

  return (
    <div className="p-8 lg:p-12" data-testid="admin-dashboard">
      <div className="mb-10">
        <div className="section-label mb-3">Genel Bakış</div>
        <h1 className="font-heading text-3xl lg:text-4xl text-white tracking-[0.05em]">Yönetim Paneli</h1>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {CARDS.map((c) => (
          <Link key={c.label} to={c.to} className="yk-card p-6 group" data-testid={`stat-${c.label}`}>
            <c.icon className="w-8 h-8 text-[#C9A961] mb-4" strokeWidth={1.2} />
            <div className="text-white/60 text-xs uppercase tracking-[0.2em] mb-2">{c.label}</div>
            <div className="font-heading text-4xl text-white group-hover:text-[#C9A961] transition-colors">{c.value}</div>
          </Link>
        ))}
      </div>

      <div className="mt-12 yk-card p-8">
        <div className="section-label mb-3">Hızlı Erişim</div>
        <h3 className="font-heading text-xl text-white tracking-widest mb-6">Yönetim Kısayolları</h3>
        <div className="flex flex-wrap gap-3">
          <Link to="/admin/projects" className="btn-gold-outline text-xs">Yeni Proje Ekle</Link>
          <Link to="/admin/services" className="btn-gold-outline text-xs">Hizmetleri Düzenle</Link>
          <Link to="/admin/messages" className="btn-gold-outline text-xs">Mesajları Görüntüle</Link>
          <Link to="/admin/settings" className="btn-gold-outline text-xs">Ayarları Aç</Link>
        </div>
      </div>
    </div>
  );
}
